import Styles from '../TitleSelector.module.scss'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'

export const SeoKeywords = ({ keywords }: { keywords: string[] }) => (
  <MobileWizard.Section gap={10}>
    <div className={Styles.seoLabel}>Your SEO keywords we tried to include</div>
    <div className={Styles.seoChips}>
      {keywords.map((keyword, i) => (
        <span key={i} className={Styles.seoChip}>
          {keyword}
        </span>
      ))}
    </div>
  </MobileWizard.Section>
)
